module.exports = __webpack_public_path__ + "img/full2-min.2ab97ef0.png";